import {
  apiClient,
  createErrorResponse,
  createSuccessResponse,
  handleApiError,
} from "../../../../shared/api";
import { notificationsConfig } from "../config/notifications.config.js";
import {
  extractNotificationsList,
  normalizeNotificationsListLimit,
} from "../lib/normalize-notifications-list.js";

/**
 * Serviço HTTP do inbox de notificações do usuário autenticado.
 */
export class NotificationService {
  constructor() {
    this.config = notificationsConfig;
  }

  /**
   * Lista notificações (`GET /notifications`).
   * `hideNonEssentialRead` só é enviado quando passado explicitamente.
   * @param {{ limit?: number|string, hideNonEssentialRead?: boolean }} [params]
   * @param {RequestInit} [requestOptions]
   */
  async list(params = {}, requestOptions) {
    const limit = normalizeNotificationsListLimit(params?.limit);

    try {
      const query = new URLSearchParams();
      query.append("limit", String(limit));
      if (typeof params?.hideNonEssentialRead === "boolean") {
        query.append(
          "hideNonEssentialRead",
          String(params.hideNonEssentialRead),
        );
      }

      const endpoint = `${this.config.paths.list}?${query.toString()}`;
      const response = await apiClient.get(endpoint, requestOptions);
      const notifications = extractNotificationsList(response);

      return createSuccessResponse(
        { notifications },
        200,
        "Notificações carregadas com sucesso",
      );
    } catch (error) {
      return handleApiError(error);
    }
  }

  /**
   * Marca notificação como lida (`POST /notifications/{notificationId}/read`).
   * @param {string} notificationId
   * @param {RequestInit} [requestOptions]
   */
  async markAsRead(notificationId, requestOptions) {
    const id =
      typeof notificationId === "string" ? notificationId.trim() : "";

    if (!id) {
      return createErrorResponse(
        "notificationId inválido",
        400,
        "INVALID_NOTIFICATION_ID",
      );
    }

    try {
      const response = await apiClient.post(
        this.config.paths.markRead(id),
        {},
        requestOptions,
      );
      const data = response?.data ?? response ?? null;
      const status =
        typeof data?.status === "string" ? data.status : "read";

      return createSuccessResponse(
        { status },
        200,
        "Notificação marcada como lida",
      );
    } catch (error) {
      return handleApiError(error);
    }
  }
}

const notificationService = new NotificationService();
export { notificationService };
export default notificationService;
